import React, { Component } from 'react'
import CenterSpin from '../../elements/CenterSpin'

const withSpinning = (WrappedComponent) => {
  return class extends Component {
    render() {
      const { fetching } = this.props
      if (fetching) return <CenterSpin spinning={fetching} />
      else return <WrappedComponent {...this.props} />
    }
  }
}

export default withSpinning
